import { all, call, put, takeLatest } from 'redux-saga/effects';
import API from '../../helpers/sagaApi/SagaApi';
import { getBranchId, getJwtToken } from '../sagaAuth/sagaAuthSaga';
import Actions, { SagaEmailTypes } from './sagaEmailRedux';

export function* requestSagaUISendEmail(action) {
    const tag = '[REQUEST_SAGA_U_I_SEND_EMAIL]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestSagaUISendEmail, jwtToken, branchId, action.emailData);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestSagaUISendEmail response :`, response.data);
                yield put(Actions.sagaUISendEmailSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestSagaUISendEmail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.sagaUISendEmailFailure(message));
    }
}



export default function* rootSaga() {
    yield all([
        takeLatest(SagaEmailTypes.REQUEST_SAGA_U_I_SEND_EMAIL, requestSagaUISendEmail),
    ]);
}


// WEBPACK FOOTER //
// ./src/redux/sagaEmail/sagaEmailSaga.ts